/**
 * «Copiar mensaje para WhatsApp» (Fase 1 de retiros, 2026-10-29): el mismo estado del retiro que va por correo (lo
 * comprado, lo retirado, lo pendiente, dónde retirarlo y el plazo, sin precios) en texto plano al portapapeles, para
 * pegarlo en WhatsApp a mano. WhatsApp no se integra (ADR-0008): el sistema no lo envía.
 */
import type { RetiroTextoDTO } from '@mg/shared';
import { MessageCircle } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/componentes/ui/button.tsx';
import { get, mensajeDeError } from '@/lib/api.ts';

/** Pide el texto al servidor y lo copia. Devuelve true si quedó en el portapapeles. */
export async function copiarEstadoRetiro(documentoId: string): Promise<boolean> {
  try {
    const r = await get<RetiroTextoDTO>('/correo/retiro-texto', { id: documentoId });
    await navigator.clipboard.writeText(r.texto);
    toast.success('Mensaje copiado', { description: 'Pégalo en el chat de WhatsApp del cliente.' });
    return true;
  } catch (e) {
    toast.error('No se pudo copiar el mensaje', { description: mensajeDeError(e) });
    return false;
  }
}

export function CopiarWhatsApp({ documentoId, enFila = false }: { documentoId: string; enFila?: boolean }) {
  const [copiando, setCopiando] = useState(false);
  return (
    <Button
      variant="outline"
      size={enFila ? 'sm' : 'default'}
      cargando={copiando}
      onClick={() => {
        setCopiando(true);
        void copiarEstadoRetiro(documentoId).finally(() => setCopiando(false));
      }}
      title="Copia el estado del retiro para enviarlo por WhatsApp"
      data-testid="copiar-whatsapp"
    >
      <MessageCircle /> {enFila ? 'WhatsApp' : 'Copiar mensaje para WhatsApp'}
    </Button>
  );
}
